import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Alert, Button, Modal } from "antd"
import printImage from "../../../helpers/printQRCode/printImage"
import drawLabel from "../../../helpers/printQRCode/drawLabel"
import { saveHistory } from "../../../services/api/3dApi"

class ExportQrCode extends Component {
    state = {
        loading: false,
        error: '',
        brandingItemPending: []
    }

    componentDidMount() {

    }

    _parseInfo = (info, basket, totalItems) => {
        const { barcode } = info || {}
        const regex = /([0-9]{5,}_)([0-9]+)/
        const parsed = barcode.match(regex)

        if (parsed) {
            return {
                orderId: `#${info.barcode}`,
                type: info.product_type,
                basket: basket,
                total: totalItems,
                size: info.product_size,
            }
        }
        return {}
    }

    _handleClickPrintQR = (item, itemIndex) => async (e) => {
        e.preventDefault()

        const { basket, totalItems, reset, errorTypeMessage, items = [] } = this.props
        const GIFTBOX_0700NO = items.length > 0 ? items.filter(item => ['GIFTBOX_0700NO'].includes(item.product_type)) : []
        const LPRO_ACCESS_00NO = items.length > 0 ? items.filter(item => ['LPRO_ACCESS_00NO'].includes(item.product_type)) : []
        const GIFTCARD_1800NO = items.length > 0 ? items.filter(item => ['GIFTCARD_1800NO'].includes(item.product_type)) : []
        const BOX_0700NO = items.length > 0 ? items.filter(item => ['BOX_0700NO'].includes(item.product_type)) : []
        const THANK_CARD = items.length > 0 ? items.filter(item => ['THANK_CARD', 'BRAND_KIT'].includes(item.product_type)) : []

        this.setState({
            [`loading_${itemIndex}`]: true,
            error: ''
        })

        try {
            const { data: response } = await saveHistory(item.barcode)
            const { success, message, error: errMsg } = response

            if (!success) {
                if (errorTypeMessage) {
                    this.setState({ [`loading_${itemIndex}`]: false })
                    Modal.error({ title: 'Lỗi', content: message || errMsg, okText: 'Đóng' })
                } else {
                    this.setState({ [`loading_${itemIndex}`]: false, error: message || errMsg })
                }
                return
            }

            this.setState({
                [`loading_${itemIndex}`]: false,
                error: ''
            }, () => {
                drawLabel(this._parseInfo(item, basket, totalItems)).then(r => printImage(r))
                if (!!reset) {
                    if (!GIFTBOX_0700NO.length && !GIFTCARD_1800NO.length && !BOX_0700NO.length && !THANK_CARD.length && !LPRO_ACCESS_00NO.length) {
                        reset()
                    }
                }
            })
        } catch (err) {
            if (errorTypeMessage) {
                this.setState({ [`loading_${itemIndex}`]: false })
                Modal.error({ title: 'Lỗi', content: err.message, okText: 'Đóng' })
            } else {
                this.setState({ [`loading_${itemIndex}`]: false, error: err.message })
            }
        }
    }

    /**
     * renderGroupButtons
     * groups: { key, items, enableBtnPrintQR }
     * enableBtnPrintQR: (item, allItems) => boolean
     */
    renderGroupButtons = (group, allItems) => {
        if (!group.items || group.items.length === 0) return null

        return group.items.map((item, idx) => {
            const [_, numberIndex] = `${item.barcode}`.split('_')
            const loadingKey = `loading_${idx}_${group.key}`
            const loading = !!this.state[loadingKey]
            const enabled = group.enableBtnPrintQR ? group.enableBtnPrintQR(item, allItems) : false

            return (
                <div className='ReleaseBasketButton' key={`${group.key}_${idx}`}>
                    <Button
                        icon={loading ? 'loading' : 'qrcode'}
                        disabled={!enabled}
                        type='primary'
                        size='large'
                        className={this.props.className || ''}
                        onClick={(e) => {
                            this.setState({ [loadingKey]: true }, () => {
                                this._handleClickPrintQR(item, `${idx}_${group.key}`)(e)
                            })
                        }}
                    >
                        In QR #{numberIndex}
                    </Button>
                </div>
            )
        })
    }

    render() {
        const { error, loading } = this.state
        const { items = [], className } = { ...this.props }
        const brandingItemPending = items.length > 0 ? items.filter(item => ['THANK_CARD', 'BRAND_KIT'].includes(item.product_type)) : []
        const otherItemsCompleted = items.length > 0 ? items.filter(item => !['THANK_CARD', 'BRAND_KIT'].includes(item.product_type) && item.status === 'completed') : []
        const isCompletedAllOtherItems = otherItemsCompleted.length === items.length - brandingItemPending.length
        const GIFTBOX_0700NO = items.length > 0 ? items.filter(item => ['GIFTBOX_0700NO'].includes(item.product_type)) : []
        const GIFTCARD_1800NO = items.length > 0 ? items.filter(item => ['GIFTCARD_1800NO'].includes(item.product_type)) : []
        const LPRO_ACCESS_00NO = items.length > 0 ? items.filter(item => ['LPRO_ACCESS_00NO'].includes(item.product_type)) : []
        const BOX_0700NO = items.length > 0 ? items.filter(item => ['BOX_0700NO'].includes(item.product_type)) : []

        const enableForBranding = (_, allItems) =>
            allItems.filter(i => !['THANK_CARD', 'BRAND_KIT', 'GIFTBOX_0700NO', 'GIFTCARD_1800NO', 'BOX_0700NO', 'LPRO_ACCESS_00NO'].includes(i.product_type))
                .every(o => o.status === "completed")

        const enableForGIFTBOX_0700NO = (item, allItems) => item.status === 'completed' && allItems.every(i => i.status === 'completed')
        const enableForBOX_0700NO = enableForGIFTBOX_0700NO // BOX_0700NO same GIFTBOX_0700NO
        const enableForLPRO_ACCESS_00NO = enableForGIFTBOX_0700NO // LPRO_ACCESS_00NO same GIFTBOX_0700NO
        const enableForGiftcard = enableForBranding // GIFTCARD same as branding

        const groups = [
            { key: 'brandingItemPending', items: brandingItemPending, enableBtnPrintQR: enableForBranding },
            { key: 'GIFTBOX_0700NO', items: GIFTBOX_0700NO, enableBtnPrintQR: enableForGIFTBOX_0700NO },
            { key: 'BOX_0700NO', items: BOX_0700NO, enableBtnPrintQR: enableForBOX_0700NO },
            { key: 'GIFTCARD_1800NO', items: GIFTCARD_1800NO, enableBtnPrintQR: enableForGiftcard },
            { key: 'LPRO_ACCESS_00NO', items: LPRO_ACCESS_00NO, enableBtnPrintQR: enableForLPRO_ACCESS_00NO },
        ]

        return <>
            {groups.map(group => this.renderGroupButtons(group, items))}
            {error && <Alert message={error} type='error' className="mt-4" />}
        </>
    }
}

ExportQrCode.propTypes = {
    items: PropTypes.array,
    basket: PropTypes.any,
    totalItems: PropTypes.number,
    reset: PropTypes.func,
    errorTypeMessage: PropTypes.any,
    className: PropTypes.string
}

export default ExportQrCode
